import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useCancelPendingAdminKyc = (): UseMutationResult<
  void,
  unknown,
  { memberId: string }
> => {
  const queryClient = useQueryClient();
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  const cancelPendingAdminKyc = async ({ memberId }: { memberId: string }) => {
    await treasureApi().delete(`/users/${memberId}/kyc-review`);
  };

  return useMutation(cancelPendingAdminKyc, {
    onSuccess: () => queryClient.refetchQueries(ReactQueryKeys.BusinessMembers),
  });
};
